import React, { Suspense, useEffect, useState } from "react";
import ImageLoader from "../chef/ImageLoader";
import mixpanel from "mixpanel-browser";
import BackBtnSvg from "../../assets/ReactSvg/BackBtnSvg";
import { InputAdornment, TextField } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { addTempUser, addWaitingList } from "../../store/loginActions";
import "./joinWaitlistComponent.css";
import { SuspenseImg } from "../util/SuspendImg";
import JoinWishListMainImage from "../../assets/ReactSvg/JoinWishListMainImage";
import BackFilledSvgIcon from "../../assets/ReactSvg/BackFilledSvgIcon";
import BackIconSvg from "../../assets/ReactSvg/BackIconSvg";
import BackFilledIconSvg from "../../assets/ReactSvg/BackFilledIconSvg";
import LinkedInIconSvg from "../../assets/ReactSvg/LinkedInIconSvg";
import InstagramIconSvg from "../../assets/ReactSvg/InstagramIconSvg";
import FacebookIconSvg from "../../assets/ReactSvg/FacebookIconSvg";
import YoutubeIconSvg from "../../assets/ReactSvg/YoutubeIconSvg";
import { Modal } from "antd";
import { loginActions } from "../../store/loginSlice";

const JoinWaitlistComponent = ({ setShowWaitListScreen }) => {
  const dispatch = useDispatch();
  const [error, setError] = useState(false);
  const [errorText, setErrorText] = useState("");
  const params = new URLSearchParams(window.location.search);
  const waitListSuccess = useSelector((state) => state.auth.waitListSuccess);
  const waitListFail = useSelector((state) => state.auth.waitListFail);
  const user = useSelector((state) => state.auth.user);
  const [isMenuModalOpen, setIsMenuModalOpen] = useState(false);
  const [locationScreen, setLocationScreen] = useState(false);
  const [location, setLocation] = useState({});
  const [loginState, setLoginState] = useState({
    name: "",
    phoneNumber: user ? user.phonenumber : "",
    referral: "",
    otp: "",
    onOtpSend: false,
  });

  const onInstagramClick = () => {
    mixpanel.track("join_waitling_list-instagram-click");
    window.open("https://www.instagram.com/cuirato/", "_blank");
  };

  const onLinkedinClick = () =>{
    mixpanel.track("join_waitling_list-linkedin-click");
    window.open("https://www.linkedin.com/company/cuirato/about/", "_blank");
    
  }

  const waitingListSubmit = () => {
    dispatch(addWaitingList(loginState.phoneNumber, enableButton, location, ));
    setLoginState({ phoneNumber: "" });
    mixpanel.track("join_waiting_list_clicked-want_referral_code");
    // clevertap.event.push("join_waiting_list_clicked-want_referral_code");
  };

  const onBackClick = () => {
    mixpanel.track("join_waitling_list-back-click");
    setShowWaitListScreen(false);
  };

  useEffect(() => {
  
    return () => {
      dispatch(loginActions.setWaitListReset());
        setIsMenuModalOpen(false)
    }
  }, [])
  

  const enableButton = () => {
    // setTimeout(() => {
    //     dispatch(loginActions.setWaitListReset());
    //     setIsMenuModalOpen(false)
    // }, 2000);
  };

  const onError = (error) => {
    console.log('error.message', error.message);
    setLocationScreen(false);
  }

  const onSuccess = (location) => {
      dispatch(
        loginActions.setCoords({
          lat: location.coords.latitude,
          lng: location.coords.longitude,
        })
      );
      const tempUser = {
        // mpUserId: localStorage.getItem("mpUserId"),
        location: {
          lat: location.coords.latitude,
          lng: location.coords.longitude,
          locationName: location.coords?.area,
        },
      };
      setLocation(tempUser)
      // dispatch(addTempUser(tempUser));
      setLocationScreen(false);
    
  };

  const requestLocation = () => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(onSuccess, onError, {
        enableHighAccuracy: false,
        timeout: 10000,
        maximumAge: 0,
      });
    }
  };

  useEffect(() => {
    if (waitListSuccess) {
      setIsMenuModalOpen(true);
    }
  }, [waitListSuccess]);

  return (
    <div className="swipe-up-enter">
      {locationScreen ? (
        <div className="login-section">
        <Suspense fallback={<ImageLoader className="loader_wrapper" />}>
          <div className="mt login-box">
            <div className="JoinWishListMainImageBoxWrapper">
              <div className="JoinWishListMainImageBox">
                <JoinWishListMainImage />
              </div>
            </div>
            <div className="login-content pg-5">
              <button
                onClick={onBackClick}
                type="button"
                className="btn back-btn joinWaitlistBackBtn"
              >
                <BackFilledIconSvg />
              </button>
            </div>
          </div>
        </Suspense>

        <div className="joinWaitlistForm">
          <div className="allowLocationLabel">
            Please allow location
          </div>
          <div className="button-box mt-30">
            <button
              className={`joinWaitlistJoinBtn Satoshi`}
              onClick={requestLocation}
            >
              <span>Allow Location</span>
            </button>
          </div>
        </div>
      </div>
      ) : (
        <>
          <div className="login-section">
            <Suspense fallback={<ImageLoader className="loader_wrapper" />}>
              <div className="mt login-box">
                <div className="JoinWishListMainImageBoxWrapper">
                  <div className="JoinWishListMainImageBox">
                    <JoinWishListMainImage />
                  </div>
                </div>
                <div className="login-content pg-5">
                  <button
                    onClick={onBackClick}
                    type="button"
                    className="btn back-btn joinWaitlistBackBtn"
                  >
                    <BackFilledIconSvg />
                  </button>
                </div>
              </div>
            </Suspense>

            <div className="joinWaitlistForm">
              <div>
                <div className={error ? "" : "hide"}>
                  <p className="error-msg">{errorText}</p>
                </div>
                <TextField
                  selectTextOnFocus={true}
                  className="material-form-field joinWaitlistText"
                  id="standard-basic"
                  name="phoneNumber"
                  label="PHONE NUMBER"
                  type="number"
                  sx={{
                    "& input[type=number]": {
                      MozAppearance: "textfield",
                      "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button":
                        {
                          WebkitAppearance: "none",
                          margin: 0,
                        },
                    },
                  }}
                  value={loginState.phoneNumber}
                  onInput={(e) => {
                    e.target.value = Math.max(0, parseInt(e.target.value))
                      .toString()
                      .slice(0, 10);
                    if (e.target.value.length == 10) {
                      e.target.blur();
                    }
                  }}
                  onChange={({ target }) => {
                    setLoginState({
                      ...loginState,
                      [target.name]: target.value,
                      otp: "",
                      onOtpSend: "",
                    });
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <div>+91</div>
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
              <div className="button-box mt-30">
                <button
                  className={`joinWaitlistJoinBtn Satoshi ${
                    loginState.phoneNumber.length !== 10 && "disabled"
                  }`}
                  disabled={loginState.phoneNumber.length !== 10}
                  onClick={waitingListSubmit}
                >
                  <span>Join Waitlist</span>
                </button>
              </div>
              <div className="joinwaitlistNotSureLabel">
                <span style={{ fontWeight: 800 }}>Not Sure?</span> Connect with
                us and stay tuned!
              </div>
              <div className="joinwaitlistSocialIcon">
              <span onClick={onLinkedinClick}><LinkedInIconSvg /></span>
              <span onClick={onInstagramClick}><InstagramIconSvg /></span>
              </div>
              <br />
              {waitListFail ? (
                <p className="waitList-msg">
                  Your number is already registered with us.
                </p>
              ) : (
                <></>
              )}
            </div>
          </div>
          <Modal
            title=""
            centered
            open={isMenuModalOpen}
            onCancel={() => setIsMenuModalOpen(false)}
            className="joinWaitPopupModal"
            wrapClassName="menuStickyPopupModalWrapClassName"
            width={400}
          >
            <div className="menuStickyPopupContainer joinwishListStickyPopupContainer">
              <div className="thankYouJoinlistHeader">Thank You 🍕</div>
              <div className="joinwaitPopupContent">
                <div className="joinwaitPopupContentDesc">
                    You can expect a message from us via WhatsApp and SMS.
                </div>
              </div>
            </div>
          </Modal>
        </>
      )}
    </div>
  );
};

export default JoinWaitlistComponent;
